var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable prettier/prettier */
/**
 * 组织架构tab 数据列表
 */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import UserSelectionContext from '../context';
import TabPaneListItem from './TabPaneListItem';
import Loading from '../../Loading';
import { DeptCrumb } from './DeptCrumb';
import { getDeptPositionDesc, getWorkLineId, mapEBookWorkLineInfo, mapEBookWorkLineUserInfo, } from '../common';
import { Empty } from 'antd';
import SelectAll from './SelectAll';
import arrowRightIcon from '../../images/app_ic_arrow_right.png';
function WorkLineDeptList(props) {
    var _a = React.useContext(UserSelectionContext), frozenIds = _a.frozenIds, canSelectDept = _a.canSelectDept, chooseOnlyDepart = _a.chooseOnlyDepart;
    var onDeptClick = props.onDeptClick, subNodeList = props.subNodeList, onItemSelect = props.onItemSelect;
    var getExtraPart = useCallback(function (deptItem) {
        if (chooseOnlyDepart || canSelectDept) {
            return (React.createElement("div", { className: deptItem.checked
                    ? "focus-user-selection-dept selection-dept-disabled"
                    : 'focus-user-selection-dept', onClick: function (event) {
                    event.stopPropagation();
                    if (!deptItem.checked) {
                        onDeptClick({
                            nodeId: deptItem.nodeId,
                            type: deptItem.type,
                        });
                    }
                } },
                React.createElement("span", { className: "focus-user-selection-dept-arrow org-dept-arrow " },
                    React.createElement("img", { src: arrowRightIcon, alt: "" }))));
        }
        return (React.createElement("span", { className: "focus-user-selection-dept-arrow", onClick: function (event) {
                onDeptClick({
                    nodeId: deptItem.nodeId,
                    type: deptItem.type,
                });
                event.stopPropagation();
            } },
            React.createElement("img", { src: arrowRightIcon, alt: "" })));
    }, [canSelectDept, chooseOnlyDepart, onDeptClick]);
    var getDisabled = useCallback(function (item) {
        return frozenIds.findIndex(function (id) { return id === item.id; }) >= 0;
    }, [frozenIds]);
    return (React.createElement("div", { className: "" }, subNodeList.map(function (item) {
        var id = item.id;
        return (React.createElement(TabPaneListItem, { disabled: getDisabled(item), key: id, data: item, checkable: chooseOnlyDepart || canSelectDept, extra: getExtraPart(item), onCheckChange: function (deptItem) {
                onItemSelect(deptItem);
            }, onClick: function () {
                if (!canSelectDept || !chooseOnlyDepart) {
                    onDeptClick({
                        nodeId: item.nodeId,
                        type: item.type,
                    });
                }
            } }));
    })));
}
function WorkLineUserList(props) {
    var _a = React.useContext(UserSelectionContext), frozenIds = _a.frozenIds, defaultUserAvatar = _a.defaultUserAvatar, single = _a.single;
    var dataList = props.dataList, onItemSelect = props.onItemSelect;
    var getDisabled = useCallback(function (item) {
        return frozenIds.findIndex(function (id) { return id === item.id; }) >= 0;
    }, [frozenIds]);
    return (React.createElement("div", null, dataList.map(function (item) {
        return (React.createElement(TabPaneListItem, { single: single, disabled: getDisabled(item), key: item.id, defualtImg: defaultUserAvatar, data: item, checkable: true, onCheckChange: function (item) {
                onItemSelect(__assign(__assign({}, item), { desc: getDeptPositionDesc({
                        deptName: item.deptName || '',
                        titleName: item.titleName || item.positionName || '',
                        unitName: (item === null || item === void 0 ? void 0 : item.unitName) || '',
                        userType: item.userType,
                    }) }));
            } }));
    })));
}
// eslint-disable-next-line complexity
export default function WorkLineList(props) {
    var _this = this;
    var _a = React.useContext(UserSelectionContext), frozenIds = _a.frozenIds, dataListFilter = _a.dataListFilter, canSelectDept = _a.canSelectDept, chooseOnlyDepart = _a.chooseOnlyDepart;
    var result = props.result, jumpCurrentOrgItem = props.jumpCurrentOrgItem, onItemCheck = props.onItemCheck, onAnalysisLog = props.onAnalysisLog, onGetEBookWorkLineInfo = props.onGetEBookWorkLineInfo;
    var _b = useState(null), eBookWorkLineInfo = _b[0], setEBookWorkLineInfo = _b[1];
    var _c = useState([]), parentNodeList = _c[0], setParentNodeList = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(null), err = _e[0], setErr = _e[1];
    var nodata = !((eBookWorkLineInfo || {}).subNodeList || []).length &&
        !((eBookWorkLineInfo || {}).emplList || []).length;
    var fetchDataList = React.useCallback(function (params) {
        if (!onGetEBookWorkLineInfo) {
            return;
        }
        setLoading(true);
        onGetEBookWorkLineInfo(params)
            .then(function (deptResult) {
            if (!deptResult) {
                return;
            }
            setErr(null);
            setEBookWorkLineInfo(deptResult);
            setParentNodeList(function () {
                var res = 
                // eslint-disable-next-line max-nested-callbacks
                deptResult.parentNodeList.map(function (item) { return ({
                    name: item.name,
                    id: getWorkLineId(item),
                    nodeId: item.nodeId || '',
                }); }) || [];
                res.unshift({
                    name: '虚拟通讯录',
                    id: '-1',
                    nodeId: '-1',
                });
                return res;
            });
        })
            .catch(function (e) {
            setErr(e);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [onGetEBookWorkLineInfo]);
    useEffect(function () {
        if (jumpCurrentOrgItem === null || jumpCurrentOrgItem === void 0 ? void 0 : jumpCurrentOrgItem.id) {
            fetchDataList({
                nodeId: jumpCurrentOrgItem.id,
            });
            return;
        }
        else {
            fetchDataList({
                nodeId: '',
            });
        }
    }, [fetchDataList, jumpCurrentOrgItem]);
    var deptClick = useCallback(function (params) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // 控制点击面包悄部门和列表项部门时的loading
                    setEBookWorkLineInfo(null);
                    return [4 /*yield*/, fetchDataList(params)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [fetchDataList]);
    var dataList = useMemo(function () {
        if (!eBookWorkLineInfo) {
            return [];
        }
        var list = mapEBookWorkLineUserInfo(eBookWorkLineInfo, result, frozenIds);
        if (dataListFilter) {
            list = list.filter(dataListFilter);
        }
        return list;
    }, [eBookWorkLineInfo, dataListFilter, frozenIds, result]);
    var workLineSubNodeList = useMemo(function () {
        return mapEBookWorkLineInfo((eBookWorkLineInfo || {}).subNodeList || [], result, chooseOnlyDepart || canSelectDept);
    }, [canSelectDept, chooseOnlyDepart, eBookWorkLineInfo, result]);
    var selectedList = useMemo(function () {
        return chooseOnlyDepart || canSelectDept ? __spreadArrays(dataList, workLineSubNodeList) || [] : dataList;
    }, [canSelectDept, chooseOnlyDepart, dataList, workLineSubNodeList]);
    // console.log(workLineSubNodeList,67777)
    var comp;
    if (loading) {
        comp = React.createElement(Loading, { style: { height: '100%' } });
    }
    else if (err) {
        comp = React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u6682\u65E0\u6570\u636E" });
    }
    else {
        comp = (React.createElement(React.Fragment, null,
            parentNodeList.length > 0 && (React.createElement(DeptCrumb, { data: parentNodeList, onItemClick: deptClick })),
            React.createElement("div", { className: "dept-user-container" },
                React.createElement(SelectAll, { dataList: selectedList || [], result: result }),
                (eBookWorkLineInfo || {}).emplList && (React.createElement(WorkLineUserList, { onItemSelect: function (user) {
                        onAnalysisLog === null || onAnalysisLog === void 0 ? void 0 : onAnalysisLog('xtbg_add_home_1637657110163', '96');
                        onItemCheck(user);
                    }, dataList: dataList || [] })),
                (eBookWorkLineInfo || {}).subNodeList && (React.createElement(WorkLineDeptList, { onItemSelect: function (dept) {
                        onItemCheck(dept);
                    }, result: result, onDeptClick: deptClick, subNodeList: workLineSubNodeList })),
                nodata && (React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u6682\u65E0\u6570\u636E" })))));
    }
    return React.createElement("div", { className: "crumb-dept-user-container" }, comp);
}
//# sourceMappingURL=WorkLine.js.map